export default function ({ store, redirect, route }) {
  if (!route.query.uid || !route.query.token) redirect("/")
}
